import React from 'react';
import { HowItWorksStoryblok } from '../../../_shared/interfaces/storyblok';
import { StoryblokCommon } from '../../../lib/storyblok/storyblok';

import * as HomeHowItWorksStylesHs from './how-it-works.hs.module.scss';
import * as HomeHowItWorksStylesDr from './how-it-works.dr.module.scss';

const HomeHowItWorks = ({ blok, storyblokCommon }: { blok: HowItWorksStoryblok; storyblokCommon: StoryblokCommon }) => {
    const HomeHowItWorksStyles = storyblokCommon.configuration.content.theme === 'dr' ? HomeHowItWorksStylesDr : HomeHowItWorksStylesHs;

    return (
        <div
            className={[
                HomeHowItWorksStyles.homeHowItWorks,
                blok.background_color?.color ? '' : HomeHowItWorksStyles.homeHowItWorksBackground,
            ].join(' ')}
            style={blok.background_color?.color ? { backgroundColor: blok.background_color?.color ?? '' } : {}}
        >
            <div className={HomeHowItWorksStyles.header}>
                <p>
                    <small>{blok.headline_small}</small>
                </p>
                <h2>{blok.headline_large}</h2>
            </div>

            <ul className={[blok.steps.length === 3 ? HomeHowItWorksStyles.threeColumns : ''].join(' ')}>
                {blok.steps.map((step: any) => {
                    return (
                        <li key={step._uid} className={HomeHowItWorksStyles[step.Icon]} data-test={step.Icon}>
                            <h4>{step.Headline}</h4>
                            <p>{step.Copytext}</p>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default HomeHowItWorks;
